import {ContactSection} from "../components/ContactSection";
import banner from "../assets/image/contact/banner.webp";
import SendMessageSection from "../components/SendMessageSection";
import AskForDetail from "../components/AskForDetail";

function ContactUsPage() {
    return (
        <>
            <img data-aos="fade-left"
                 data-aos-duration="400"
                 src={banner} className="aspect-3.5 max-md:aspect-2 w-full object-cover" alt="Banner"/>
            <ContactSection/>
            <SendMessageSection/>
            <AskForDetail/>
        </>
    );
}

export default ContactUsPage;



